/**
 * @fileoverview Custom OpenLayers control for fitting map view to visible POI.
 * @module map/FitExtentControl
 */

/**
 * Custom OpenLayers control that provides a button to fit the map view to all visible POI markers.
 * Displays a fit extent icon that triggers the onFitExtent callback when clicked.
 * @class
 * @extends ol.control.Control
 */
export class FitExtentControl extends ol.control.Control {
    /**
     * Creates a new FitExtentControl instance.
     * @param {Object} [options={}] - Control options
     * @param {Function} [options.onFitExtent] - Callback invoked when fit extent button is clicked
     * @param {HTMLElement} [options.target] - Target element to render the control into
     */
    constructor(options = {}) {
        const button = document.createElement('button');
        button.innerHTML = '<i class="bi bi-aspect-ratio"></i>';
        button.className = 'ol-fit-extent-button';
        button.title = 'Fit view to visible markers';

        const element = document.createElement('div');
        element.className = 'ol-fit-extent ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target
        });

        this.onFitExtent = options.onFitExtent || (() => {});

        // Handle button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onFitExtent();
        });
    }
}
